/**
 * @fileoverview POST handler for the "/apps/catalog_fields" endpoint
 */
import { appsCatalogFieldsCacheKeys } from "@dashboardApi/apis/appsCatalogFields/constants";
import type { AppsCatalogCreateFieldsParams } from "@dashboardApi/apis/appsCatalogFields/types";
import { reactQueryMutationAdapter } from "@dashboardApi/apis/reactQueryFetcherAdapters";

import fetch from "@lib/fetch";

export const postAppsCatalogFields = reactQueryMutationAdapter(
  appsCatalogFieldsCacheKeys,
  async (props: AppsCatalogCreateFieldsParams): Promise<any> => {
    return fetch(`/apps/catalogs/${props.catalog_id}/fields`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
